import React, { Dispatch, SetStateAction, useEffect } from 'react';
import './catalan-language-toggle.scss';
import { OwnerManualResponse } from '../../../support/services/owner-manual-service/owner-manual-service';
import { OwnerManualProps } from '../../../support/pages/owner-manual/hook/use-owner-manual-content';

interface Props {
    setToggleSwitch: Dispatch<SetStateAction<boolean>>;
    ownerManualData: OwnerManualResponse | null;
    ownerManualContent: OwnerManualProps;
    ownerManualCaData: OwnerManualResponse | null;
    setErrorMsg: Dispatch<SetStateAction<string>>;
    catalanToggle: boolean;
    setCatalanToggle: Dispatch<SetStateAction<boolean>>;
    defaultSpanishToggle: boolean;
    setDefaultSpanishToggle: Dispatch<SetStateAction<boolean>>;
}

export const CatalanLanguageToggle = (props: Props) => {
    const errorMessageForOwnerManuals = () => {
        props.setErrorMsg('');
        if (
            props.ownerManualContent &&
            !props.ownerManualContent.hideContent &&
            props.ownerManualContent.title != 'loading' &&
            (props.ownerManualCaData || props.ownerManualData)
        ) {
            const showErrorMessage = props.setErrorMsg(
                props.ownerManualContent.detailsEmptyApiResponse
            );

            if (
                props.ownerManualCaData?.metadata.error &&
                !props.catalanToggle &&
                props.defaultSpanishToggle
            ) {
                return showErrorMessage;
            } else {
                props.setErrorMsg('');
            }

            if (
                props.ownerManualData?.metadata.error &&
                props.catalanToggle &&
                !props.defaultSpanishToggle
            ) {
                return showErrorMessage;
            } else {
                props.setErrorMsg('');
            }
        }
    };

    const esOnClick = () => {
        props.setCatalanToggle(false);
        props.setDefaultSpanishToggle(true);
        props.setToggleSwitch(false);
        errorMessageForOwnerManuals();
    };

    const caOnClick = () => {
        props.setDefaultSpanishToggle(false);
        props.setCatalanToggle(true);
        props.setToggleSwitch(true);
        errorMessageForOwnerManuals();
    };

    useEffect(() => {
        props.setDefaultSpanishToggle(true);
    }, []);

    return (
        <div className="catalan-language-toggle-container">
            <div
                className="catalan-language-toggle"
                data-testid="catalan-language-toggle"
            >
                <a
                    onClick={() => {
                        esOnClick();
                    }}
                    className={`toggle-link-es ${
                        props.defaultSpanishToggle
                            ? 'default-selected-language'
                            : 'default-un-selected-language'
                    }`}
                    aria-label="spanish-language-toggle"
                    data-testid="default-selected-language"
                    target=""
                >
                    ES
                </a>
                |
                <a
                    onClick={() => {
                        caOnClick();
                    }}
                    aria-label="catalan-language-toggle"
                    className={`toggle-link-ca ${
                        props.catalanToggle
                            ? 'catalan-selected-language'
                            : 'catalan-un-selected-language'
                    }`}
                    data-testid="ca-selected-language"
                    target=""
                >
                    CA
                </a>
            </div>
        </div>
    );
};
